export default __webpack_public_path__ + "static/media/LexendDeca-Medium.191d68a2.ttf";